__turbopack_context__.v({
  "success": "Tooltip-module-scss-module__3W-tSq__success",
  "tooltip": "Tooltip-module-scss-module__3W-tSq__tooltip",
});
